import React, { useEffect, useState } from "react";
import axios from "axios";
import SecureLS from "secure-ls";
import Swal from 'sweetalert2';
import swal from "sweetalert";
import { useNavigate } from 'react-router-dom';
import  {encrypt}  from "../../utils/cipher.js";
import Loader from "../utils/Loader/Loader";

const Redirect = () => {
const navigate = useNavigate();
  useEffect(() => {
    var ls = new SecureLS();
    let searchParams = new URLSearchParams(window.location.search);
    let token = searchParams.get("token");
    if (!token && !ls.get("token")) {
      swal("Oops!", "Something went wrong", "warning");
      navigate("/login");
    } else {
      if (token) {
        let payload = {
          token: token,
        };
        const encryptedReqBody = encrypt(payload);
        axios
          .post(`${process.env.REACT_APP_BACKEND_URL}/AddEntraId`, {
            payload: encryptedReqBody,
          })
          .then((res) => {
            console.log("Response from Entra API", res);
            if (res?.data?.loginSuccess) {
              ls.set("isUserLoggedIn", true);
              ls.set("token", res?.data?.token);
              ls.set("fname", res?.data?.user?.firstName);
              ls.set("lname", res?.data?.user?.lastName);
              ls.set("phno", res?.data?.user?.phNumber);
              ls.set("userType", res?.data?.user?.userType);
              ls.set("userEmail", res?.data?.user?.email);
              navigate("/app/daily");
            } else {
              Swal.fire({
                title: "Error",
                text: `${res.data.message}`,
                icon: "error",
                confirmButtonText: "Retry",
                confirmButtonColor: "#1C81C4",
              });
              navigate("/");
            }
          })
          .catch((err) => {
            console.log("Error in tryCatch ENTRA ID--", err);
            ls.clear();
            navigate("/");
          });
      } else {
        navigate("/");
      }
    }
  }, []);

  return <div>
    <Loader/>
  </div>;
};

export default Redirect;
